import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';
import { computed, observable } from 'mobx-angular';
import { ChartData } from 'chart.js';
import { IDeploySensitivityWeighting } from '../../interfaces/deploy-priority/deploy-sensitivity-weighting';
import { DeploySensitivityWeightingService } from '../../services';

@Component({
  selector: 'deploy-sensitivity-weightings',
  templateUrl: './deploy-sensitivity-weightings.component.html',
  //styleUrls: ['./deploy-sensitivity-weightings.component.scss'],
})
export class DeploySensitivityWeightingsComponent implements OnInit {
  public showEditWeightings: boolean = false;

  @observable public weighting: IDeploySensitivityWeighting = {
    id: 0,
    organisationLongTerm: 0.25,
    organisationShortTerm: 0.25,
    enhancedChecklist: 0.25,
    leadTime: 0.25,
    lastUpdated: new Date(),
  };

  @observable public updateWeightingDto: IDeploySensitivityWeighting = null;

  @computed public get sumOfWeights() {
    if (!this.updateWeightingDto) {
      return 0;
    }
    return [
      this.updateWeightingDto.organisationLongTerm,
      this.updateWeightingDto.organisationShortTerm,
      this.updateWeightingDto.enhancedChecklist,
      this.updateWeightingDto.leadTime,
    ].reduce((a, b) => Number(a) + Number(b));
  }

  constructor(
    private jobSensitivityService: DeploySensitivityWeightingService,
    private messageService: MessageService,
  ) {}

  ngOnInit() {
    this.getCurrentWeighting();
  }

  @computed get chartData(): ChartData {
    return {
      labels: [
        'Organisation Long Term',
        'Organisation Short Term',
        'Lead Time',
        'Enhanced Checklist',
      ],
      datasets: [
        {
          data: [
            this.weighting.organisationLongTerm,
            this.weighting.organisationShortTerm,
            this.weighting.leadTime,
            this.weighting.enhancedChecklist,
          ],
          backgroundColor: [
            'rgba(174,202,246,0.72)',
            'rgba(250,129,140,0.42)',
            'rgba(150,245,167,0.56)',
            '#f6cca2',
          ],
        },
      ],
    };
  }

  editWeighting() {
    this.updateWeightingDto = {
      ...this.weighting,
      id: 0,
    };
    this.showEditWeightings = true;
  }

  getCurrentWeighting() {
    this.jobSensitivityService.getCurrentWeighting().then((w) => {
      if (w) {
        this.weighting = w;
      }
    });
  }

  async saveWeightings() {
    try {
      await this.jobSensitivityService.updateWeighting(this.updateWeightingDto);
      this.messageService.add(Message.Success('Weightings Updated'));
      this.getCurrentWeighting();
      this.showEditWeightings = false;
    } catch (e) {
      this.messageService.add(Message.Error('An error occurred whilst updating weightings'));
    }
  }
}
